// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"_2HTL4","cardTitle":"KMBWZ","cardItem":"_27TFW","cardItemCover":"Ufi-x","cardItemTitle":"_2nNkJ","cardItemValue":"_6kbPI"};